import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { map, take } from 'rxjs';

export const supplyChainSupportGuard: CanActivateFn = (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.user$.pipe(
    take(1),
    map((user) => {
      const roles = (user?.['https://efactorypro.com/roles'] as string[]) ?? [];

      return roles.includes('Supply Chain Support') || roles.includes('Admin')
        ? true
        : router.createUrlTree(['/redirect']);
    })
  );
};
